/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateQuantiferonTestDtoInterpretation =
  (typeof CreateQuantiferonTestDtoInterpretation)[keyof typeof CreateQuantiferonTestDtoInterpretation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuantiferonTestDtoInterpretation = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  NOT_EXECUTED: 'NOT_EXECUTED',
  PENDING: 'PENDING',
  NONE: 'NONE',
} as const;
